export const integrationOptions = [
  { label: "Web Provisioning", value: "Web Provisioning" },
  { label: "App Provisioning", value: "App Provisioning" },
  { label: "iOS SDK", value: "iOS SDK" },
  { label: "Android SDK", value: "Android SDK" },
  { label: "Origo API", value: "Origo API" },
  { label: "OIP Android Integration", value: "OIP Android Integration" },
  { label: "OIP IOS Integration", value: "OIP IOS Integration" },
];
